import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { ImportConfig, ImportButtonVariant } from '../../interfaces/import-config.interface';
import { ImportDialogComponent } from '../import-dialog/import-dialog.component';
import { ImportApiResponse } from '../../interfaces/import-response.interface';

@Component({
  selector: 'app-import-button',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule
  ],
  template: `
    <ng-container [ngSwitch]="variant.type">
      
      <!-- Mat Menu Variant -->
      <div *ngSwitchCase="'mat-menu'">
        <button 
          mat-menu-item 
          [color]="variant.color || ''"
          [disabled]="disabled"
          (click)="openImportDialog()"
          class="flex items-center gap-2">
          <mat-icon>upload</mat-icon>
          <span>{{ buttonText }}</span>
        </button>
      </div>

      <!-- Regular Button Variant -->
      <div *ngSwitchCase="'button'">
        <button 
          mat-raised-button 
          [color]="variant.color || 'primary'"
          [disabled]="disabled"
          (click)="openImportDialog()"
          class="flex items-center gap-2">
          <mat-icon>upload</mat-icon>
          <span>{{ buttonText }}</span>
        </button>
      </div>

      <!-- FAB Variant -->
      <div *ngSwitchCase="'fab'">
        <button 
          mat-fab 
          [color]="variant.color || 'primary'"
          [disabled]="disabled"
          (click)="openImportDialog()"
          [attr.aria-label]="buttonText">
          <mat-icon>upload</mat-icon>
        </button>
      </div>

    </ng-container>
  `,
  styles: [`
    :host {
      width: 100%;
      display: inline-block;
    }
    
    button[disabled] {
      opacity: 0.6;
      cursor: not-allowed;
    }
    
    .flex {
      display: flex;
    }
    
    .items-center {
      align-items: center;
    }
    
    .gap-2 {
      gap: 0.5rem;
    }
  `]
})
export class ImportButtonComponent {
  @Input() config!: ImportConfig;
  @Input() buttonText: string = 'Importar';
  @Input() variant: ImportButtonVariant = { type: 'mat-menu' };
  @Input() disabled: boolean = false;
  @Input() icon: string = 'upload';

  @Output() importStarted = new EventEmitter<void>();
  @Output() importCompleted = new EventEmitter<ImportApiResponse>();
  @Output() importCancelled = new EventEmitter<void>();
  @Output() importError = new EventEmitter<any>();

  constructor(private dialog: MatDialog) {}

  openImportDialog(): void {
    if (this.disabled || !this.config) {
      return;
    }

    this.importStarted.emit();

    const dialogRef = this.dialog.open(ImportDialogComponent, {
      width: '95vw',
      maxWidth: '1500px',
      height: '95vh',
      maxHeight: '95vh',
      disableClose: false,
      data: {
        config: this.config
      },
      panelClass: 'import-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.cancelled) {
          this.importCancelled.emit();
        } else if (result.success) {
          this.importCompleted.emit(result.data);
        } else if (result.error) {
          this.importError.emit(result.error);
        }
      } else {
        this.importCancelled.emit();
      }
    });
  }
}